import React, { Component } from "react";
import styled from "styled-components";
import { LBFooter } from "components";

const PageContainer = styled.div`
  max-width: 1120px;
  margin: auto;
  display: flex;
  flex-direction: column;
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const LeftBodyChild = styled.div`
  display: flex;
  flex: 9;
`;
const RightBodyChild = styled.div`
  display: flex;
  flex: 2;
  padding-bottom: 4em;
`;
const FooterContainer = styled.div`
  margin-top: 25px;
  background: #f7f7f7;
`;

export class CardPageLayoutNoBanner extends Component {
  render() {
    const { leftComponent, rightComponent, ...otherProps } = this.props;

    return (
      <PageContainer>
        <BodyContainer {...otherProps}>
          <LeftBodyChild>{leftComponent}</LeftBodyChild>
          <RightBodyChild>{rightComponent}</RightBodyChild>
        </BodyContainer>
        <FooterContainer>
          <LBFooter />
        </FooterContainer>
      </PageContainer>
    );
  }
}
